/* eslint-disable react/jsx-props-no-spreading */
import React, { memo, useRef, useLayoutEffect } from "react";
import { OutlinedInput } from "@mui/material";

import usePrevious from "./usePrevious";

// export interface SingleOTPInputProps
//   extends React.InputHTMLAttributes<HTMLInputElement> {
//   focus?: boolean;
// }

export function SingleOTPInputComponent(props) {
  const { focus, autoFocus, ...rest } = props;
  const inputRef = useRef(null);
  const prevFocus = usePrevious(!!focus);
  useLayoutEffect(() => {
    if (inputRef.current) {
      if (focus && autoFocus) {
        inputRef.current.focus();
      }
      if (focus && autoFocus && focus !== prevFocus) {
        inputRef.current.focus();
        inputRef.current.select();
      }
    }
  }, [autoFocus, focus, prevFocus]);

  return (
    <OutlinedInput
      className="otp-input-div"
      inputProps={{
        style: {
          backgroundColor: "#fff",
          border: "none",

          textAlign: "center",
        },
        ...rest,
      }}
      placeholder="-"
      // size="small"
      inputRef={inputRef}
      {...rest}
    />
  );
}

const SingleOTPInput = memo(SingleOTPInputComponent);
export default SingleOTPInput;
